import { Icon, Text, HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Pressable } from 'native-base';
import { useCallback } from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../../../../routes/types';
import { moduleName } from '../../../constants';

export const InvestmentStrategyNavigationBar = () => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const handleGoBack = useCallback(() => {
    navigate('AppDrawer', {
      screen: 'Home',
      params: { initialTabIndex: 1 },
    });
  }, [navigate]);

  return (
    <HStack alignItems="center" paddingY={Spacing['stack.xxs']}>
      <Pressable onPress={handleGoBack}>
        <Icon name="ArrowLeft" size="xs" />
      </Pressable>
      <Text fontSize={Typography['fontsize.lg']} variant="bold">
        {moduleName}
      </Text>
    </HStack>
  );
};
